import rezone from '../helpers/rezone.fn.js';
import init_tel_mask from '../helpers/init_tel_mask.fn.js';

document.addEventListener('markup_delivered', (e) => {

	let elements = [];

	if( e.detail.initiator.getAttribute('data-load') == e.detail.url ){

		if( e.detail.initiator.hasAttribute('data-replace') ){

			let anchor = e.detail.initiator.nextElementSibling;

			e.detail.initiator.insertAdjacentHTML('afterend', e.detail.payload.markup);

			let pointer = e.detail.initiator.nextElementSibling;
			while( pointer != anchor ){
				elements.push( pointer );
				pointer = pointer.nextElementSibling;
			}

			e.detail.initiator.remove()

		} else{

			e.detail.initiator.innerHTML = e.detail.payload.markup;
			[...e.detail.initiator.children].map((c) => elements.push(c))

		}		

	} else if( e.detail.initiator.getAttribute('data-isa') == 'more_button' ) {

		let anchor = e.detail.initiator.previousElementSibling;

		e.detail.initiator.insertAdjacentHTML('beforebegin', e.detail.payload.markup);

		let pointer = anchor ? anchor.nextElementSibling : e.detail.initiator.parentNode.firstChild;
		while( pointer != e.detail.initiator ){
			elements.push( pointer );
			pointer = pointer.nextElementSibling;
		}

		e.detail.initiator.remove();

	}

	// Making rezone
	elements.map((el) => {

		[...el.querySelectorAll('[data-date]')].map(rezone);
		[...el.querySelectorAll('input[type="tel"]')].map(init_tel_mask);

	});

	// Some elements wanna react when markup is delivered
	[... document.querySelectorAll('[data-listen="markup_delivered"]')].map((el) => {

		if( el.getAttribute('data-markup-isa') == e.detail.payload.isa ){

			let [modification,arg] = el.getAttribute('data-modify').split(':');
			if( modification == 'drop_class' ){
				el.classList.remove(arg);
			} else if( modification == 'drop_style' ){
				el.removeAttribute('style');
			} else if( modification == 'replace' ){
				el.insertAdjacentHTML( 'beforebegin', e.detail.payload.markup );
				el.remove()
			}

		}

	});

	// Some code wanna react on delivered markup render complete
	document.dispatchEvent(
		new CustomEvent("delivered_markup_rendered", {detail: {
			elements: elements
		}})
	)

})

